var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appBox",attrs:{"id":"app"}},[_c('Index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }